import BaseMessageHandler from '../BaseMessageHandler';
import { updateFiltersValues } from 'actions/filtersValues';

export default class DictionariesUpdated extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateFiltersValues(message.payload));
  };
}
